import EntityBaseRepository from '@/api/misc/EntityBaseRepository';
import { AxiosResponse } from 'axios';
import { Audience } from '@/enum/Audience.enum';

export interface AnnouncementFilters {
    page?: number,
    pageSize?: number,
    status?: string
}

export interface AnnouncementPayload {
    title: string,
    body: string,
    audience: Audience,
    company?: string,
    activeFrom?: string,
    activeUntil?: string
}

/**
 * Admin announcements: stored, auditable broadcasts. `create` only saves a
 * draft -- nothing is sent until `publish`, which the view calls after the
 * admin confirms the recipient count shown by `recipientCount`.
 */
export default class AnnouncementRepository extends EntityBaseRepository {
    public list(filters: AnnouncementFilters = {}): Promise<AxiosResponse> {
        const params = new URLSearchParams();
        Object.entries(filters).forEach(([key, value]) => {
            if (value !== undefined && value !== null && value !== '') {
                params.append(key, String(value));
            }
        });
        const query = params.toString();
        return this.axiosClient.get(`announcement${query ? `?${query}` : ''}`);
    }

    public create(payload: AnnouncementPayload): Promise<AxiosResponse> {
        return this.axiosClient.post('announcement', payload);
    }

    public publish(id: string): Promise<AxiosResponse> {
        return this.axiosClient.post(`announcement/${id}/publish`);
    }

    public archive(id: string): Promise<AxiosResponse> {
        return this.axiosClient.post(`announcement/${id}/archive`);
    }

    public recipientCount(audience: Audience, company?: string): Promise<AxiosResponse> {
        const params = new URLSearchParams({ audience: String(audience) });
        if (company) {
            params.append('company', company);
        }
        return this.axiosClient.get(`announcement/recipient-count?${params.toString()}`);
    }
}
